/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'recycle': {
    width: 200.072,
    height: 200,
    viewBox: '0 0 200.072 200',
    data: '<g fill-rule="evenodd" _fill="#000"><path pid="0" opacity=".9" d="M0 25.13v15.43h19.31V200h161.6V40.63h19.16V25.21h-44.24V0H44.86v25.13H0zm60.252 0h80.18v-9.71h-80.18v9.71zm105.35 15.502H34.782v143.95h130.82V40.632z"/><path pid="1" opacity=".9" d="M109.267 98.332l8.31-16.35-10-17.42h-13.39l-26.24 45.57h17.78l15.15-26.29 8.39 14.49zm3.466 36.088l8.85 15.42h21.78l6.61-11.57-26.93-46.8-8.39 16.27 15.39 26.68h-17.31zm-1.695 15.416l-8.85-15.42h-30.47l8.77-15.19h-17.77l-10.93 19.04 6.62 11.57h52.63z"/></g>'
  }
})
